import {
  UploadMarketplaceFeatureImage,
  UploadMarketplaceFeatureImageVariables
} from './__generated__/UploadMarketplaceFeatureImage'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation UploadMarketplaceFeatureImage($input: MarketplaceFeatureImageInputV2!) {
    uploadMarketplaceFeatureImageV2(input: $input) {
      ... on MarketplaceGalleryErrorV2 {
        type
        error
      }
      ... on MarketplaceGalleryUploadV2 {
        uploadUrl
      }
    }
  }
`

export const useUploadMarketplaceListingFeatureImage = () =>
  useMutation<UploadMarketplaceFeatureImage, UploadMarketplaceFeatureImageVariables>(MUTATION)
